import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { fr, enUS, es } from "date-fns/locale";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DATE_SELECTORS } from "../../../../constants";
import styles from "./DateFilter.module.css";
import { formatDateYMD, isNonEmptyArray } from "../../../../utils";
import { translate } from "../../../../providers";

const DateFilter = ({ filterKey, onChange, value }) => {
	const language = useSelector(({ context }) => context.language.value);
	const localeLanguage = useMemo(
		() => (language === "en" && enUS) || (language === "fr" && fr) || (language === "esp" && es) || enUS,
		[language]
	);
	const handleDateChange = (date, side) => {
		if (onChange && typeof onChange === "function") {
			if (value?.length === 1 || value === null || value === undefined) {
				onChange([
					{
						value: formatDateYMD(date),
						valueUuid: filterKey,
						relation: value?.[0].relation || DATE_SELECTORS.IS_ON,
					},
				]);
			} else {
				// eslint-disable-next-line prefer-const
				const dates = [...value];
				const newDate = formatDateYMD(date);
				if (dates[0]?.value || dates[1]?.value) {
					if (side === 0) {
						const otherDate = dates[1]?.value;
						if (otherDate && newDate > otherDate) {
							dates[0] = { ...date[0], value: otherDate };
							dates[1] = { ...date[1], value: newDate };
						} else {
							dates[0] = { ...date[0], value: newDate };
						}
					} else if (side === 1) {
						const otherDate = dates[0]?.value;
						if (otherDate && newDate < otherDate) {
							dates[1] = { ...date[1], value: otherDate };
							dates[0] = { ...date[0], value: newDate };
						} else {
							dates[1] = { ...date[1], value: newDate };
						}
					}
				} else {
					dates[side].value = newDate;
				}
				onChange(
					dates.map((d, index) => ({
						...d,
						valueUuid: filterKey,
						relation: index === 0 ? DATE_SELECTORS.IS_OR_IS_AFTER : DATE_SELECTORS.IS_OR_IS_BEFORE,
					}))
				);
			}
		}
	};
	return (
		<div className={styles.main}>
			<LocalizationProvider adapterLocale={localeLanguage} dateAdapter={AdapterDateFns}>
				{(isNonEmptyArray(value) && value?.length !== 1 && (
					<div className={styles.doubleDateContainer}>
						<StaticDatePicker
							localeText={{ toolbarTitle: translate("common:component.filters.date.period.start") }}
							slotProps={{ actionBar: { actions: [] } }}
							value={new Date(value?.[0]?.value)}
							onChange={(val) => handleDateChange(val, 0)}
						/>
						<StaticDatePicker
							localeText={{ toolbarTitle: translate("common:component.filters.date.period.end") }}
							slotProps={{ actionBar: { actions: [] } }}
							value={new Date(value?.[1]?.value)}
							onChange={(val) => handleDateChange(val, 1)}
						/>
					</div>
				)) || (
					<StaticDatePicker
						localeText={{
							toolbarTitle: translate("common:component.filters.date.single-date.toolbar.title"),
						}}
						slotProps={{ actionBar: { actions: [] } }}
						value={new Date(value?.[0]?.value)}
						onChange={handleDateChange}
					/>
				)}
			</LocalizationProvider>
		</div>
	);
};

export default DateFilter;
